document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if(menuBtn && mobileMenu) menuBtn.addEventListener('click',()=>mobileMenu.classList.toggle('open'));

  const toast = (m) => {
    const el = document.getElementById('TZToast');
    if(!el) return;
    el.textContent=m; el.classList.add('show');
    setTimeout(()=>el.classList.remove('show'),1400);
  };

  document.querySelectorAll('[data-wishlist]').forEach(btn=>{
    const id=btn.dataset.wishlist;
    const key='trynzoo_wishlist';
    const get=()=>JSON.parse(localStorage.getItem(key)||'[]');
    const setState=()=>btn.classList.toggle('active',get().includes(id));
    setState();
    btn.addEventListener('click',()=>{
      let items=get();
      items=items.includes(id)?items.filter(x=>x!==id):[...items,id];
      localStorage.setItem(key,JSON.stringify(items));
      setState(); toast(items.includes(id)?'Saved to wishlist':'Removed from wishlist');
    });
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{
    form.addEventListener('submit',()=>toast('Adding to cart…'));
  });
});